<template>
    <div>
        <loading-container v-if="loading"></loading-container>

        <div v-else class="container">
            <div class="panel panel-default">
                <div class="panel-body">
                    <table class="table table-condensed table-striped">
                        <thead>
                            <tr>
                                <th class="col-xs-1 text-center">
                                    <input type="checkbox" :disabled="true">
                                </th>

                                <th class="col-xs-14">
                                    Order Title
                                </th>

                                <th class="col-xs-8">
                                    Date
                                </th>

                                <th class="col-xs-1"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="orderConfirmation in orderConfirmations.data">
                                <td class="text-center">
                                    <input type="checkbox" :disabled="true">
                                </td>

                                <td>
                                    {{ orderConfirmation.order_title }}
                                </td>

                                <td>
                                    {{ orderConfirmation.created_at | date }}
                                </td>

                                <td class="text-right">
                                    <div class="btn-group list-actions">
                                        <a :href="'/api/v1/order-confirmations/' + orderConfirmation.id + '?token=' + shared.token" class="btn btn-sm">
                                            <i class="fa fa-search"></i>
                                        </a>

                                        <button type="button" class="btn btn-sm" :disabled="true">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            <tr v-if="!orderConfirmations.data.length">
                                <td colspan="7" class="text-center">
                                    <i>
                                        There are no order confirmations to display.
                                    </i>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-xs-offset-6 col-xs-12">
                            <pager :pagination="orderConfirmations.meta" @navigate="navigate"></pager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import modal from '@/modal'
    import notify from '@/notify'
    import store from '@/store'
    import Load from '@/mixins/Load'
    import LoadingContainer from '@/components/Layout/LoadingContainer'
    import Pager from '@/components/Lists/Pager'
    import StatusLabel from '@/components/StatusLabel'

    export default {
        components: {LoadingContainer, Pager, StatusLabel},

        mixins: [Load],

        model: {
            prop: 'company',
            event: 'company-updated'
        },

        props: ['company'],

        data() {
            return {
                orderConfirmations: {},
                shared: store,
                page: this.getQueryParam('page', 1)
            }
        },

        watch: {
            '$route'() {
                this.load()
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            queryString() {
                return '?page=' + this.page
            }
        },

        methods: {
            load() {
                this.loading = true

                http.get('/api/v1/order-confirmations', {
                    company: this.company.data.id,
                    page_size: 25,
                    page: this.page
                })
                    .then(response => {
                        this.orderConfirmations = response.data

                        this.loading = false
                    })
            },

            navigate(page) {
                this.page = page

                if (this.page === parseInt(this.$route.query.page)) {
                    this.load()
                }

                this.$router.push('order-confirmations' + this.queryString)
            },

            getQueryParam(key, defaultValue = null) {
                return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
            }
        }
    }
</script>
